/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.0.13.0 (NJsonSchema v9.13.17.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

//import { IConfigApiClient } from 'src/app/config-client/common-config.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { env } from 'process';

export const SIDELOADER_API_BASE_URL = new InjectionToken<string>('SIDELOADER_API_BASE_URL');

export class SideLoaderClientBase {
  private bearerToken: string;

  get serviceName() {
    return 'SideLoaderContentService';
  }

  setToken(token: string) {
    this.bearerToken = token;
  }

  public setBaseUrl(baseUrl: string) {
    (<any>this).baseUrl = baseUrl;
  }

  transformOptions(options: any): Promise<any> {
    options.headers = (<HttpHeaders>options.headers).append('Authorization', `Bearer ${this.bearerToken}`);

    return Promise.resolve(options);
  }
}

@Injectable()
export class ContentClient extends SideLoaderClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    // Temp (manual) change just to get the auth stuff going, we'll have to figure out how this base
    // url is going to be injected now that common config goes away.
    //constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SIDELOADER_API_BASE_URL) baseUrl?: string) {
    constructor(@Inject(HttpClient) http: HttpClient) {
        super();
        this.http = http;
        //this.baseUrl = baseUrl ? baseUrl : "https://__SERVICEHOST__/api";
        this.baseUrl = environment.apiUrl;
    }

    getPlatformList(): Observable<PlatformModel[] | null> {
        let url_ = this.baseUrl + "/V1/Platforms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlatformList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformList(<any>response_);
                } catch (e) {
                    return <Observable<PlatformModel[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlatformModel[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlatformList(response: HttpResponseBase): Observable<PlatformModel[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlatformModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlatformModel[] | null>(<any>null);
    }

    getApplicationList(platform: string): Observable<ApplicationModel[] | null> {
        let url_ = this.baseUrl + "/V1/Platforms/{platform}/Applications";
        if (platform === undefined || platform === null)
            throw new Error("The parameter 'platform' must be defined.");
        url_ = url_.replace("{platform}", encodeURIComponent("" + platform)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetApplicationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationList(<any>response_);
                } catch (e) {
                    return <Observable<ApplicationModel[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationModel[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationList(response: HttpResponseBase): Observable<ApplicationModel[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApplicationModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationModel[] | null>(<any>null);
    }

    getVersionList(appId: string): Observable<VersionModel[] | null> {
        let url_ = this.baseUrl + "/V1/Applications/{appId}/Versions";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVersionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionList(<any>response_);
                } catch (e) {
                    return <Observable<VersionModel[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<VersionModel[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetVersionList(response: HttpResponseBase): Observable<VersionModel[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VersionModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VersionModel[] | null>(<any>null);
    }

    getDownloadContentItem(platform: string, appId: string, versionId: string): Observable<DownloadContentModel | null> {
        let url_ = this.baseUrl + "/V1/Platforms/{platform}/Applications/{appId}/Versions/{versionId}";
        if (platform === undefined || platform === null)
            throw new Error("The parameter 'platform' must be defined.");
        url_ = url_.replace("{platform}", encodeURIComponent("" + platform)); 
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId)); 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDownloadContentItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadContentItem(<any>response_);
                } catch (e) {
                    return <Observable<DownloadContentModel | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<DownloadContentModel | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDownloadContentItem(response: HttpResponseBase): Observable<DownloadContentModel | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DownloadContentModel.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadContentModel | null>(<any>null);
    }

    getBinaryItem(platform: string, appId: string, versionId: string, fileName: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/V1/Platforms/{platform}/Applications/{appId}/Versions/{versionId}/Files/{fileName}";
        if (platform === undefined || platform === null)
            throw new Error("The parameter 'platform' must be defined.");
        url_ = url_.replace("{platform}", encodeURIComponent("" + platform)); 
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId)); 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId)); 
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBinaryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBinaryItem(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetBinaryItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getDirectDownloadUrl(platform: string, appId: string, versionId: string, fileName: string): Observable<string | null> {
        let url_ = this.baseUrl + "/V1/Platforms/{platform}/Applications/{appId}/Versions/{versionId}/FileUrls/{fileName}";
        if (platform === undefined || platform === null)
            throw new Error("The parameter 'platform' must be defined.");
        url_ = url_.replace("{platform}", encodeURIComponent("" + platform)); 
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId)); 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId)); 
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDirectDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectDownloadUrl(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<string | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectDownloadUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string | null>(<any>null);
    }
}

export class PlatformModel implements IPlatformModel {
    platform?: string | undefined;
    advertisingImage?: string | undefined;

    constructor(data?: IPlatformModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.platform = data["platform"];
            this.advertisingImage = data["advertisingImage"];
        }
    }

    static fromJS(data: any): PlatformModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["advertisingImage"] = this.advertisingImage;
        return data; 
    }
}

export interface IPlatformModel {
    platform?: string | undefined;
    advertisingImage?: string | undefined;
}

export class ApplicationModel implements IApplicationModel {
    appID?: string | undefined;
    title?: string | undefined;
    advertisingImage?: string | undefined;
    helpContent?: string | undefined;
    latestVersion?: string | undefined;

    constructor(data?: IApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appID = data["appID"];
            this.title = data["title"];
            this.advertisingImage = data["advertisingImage"];
            this.helpContent = data["helpContent"];
            this.latestVersion = data["latestVersion"];
        }
    }

    static fromJS(data: any): ApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appID"] = this.appID;
        data["title"] = this.title;
        data["advertisingImage"] = this.advertisingImage;
        data["helpContent"] = this.helpContent;
        data["latestVersion"] = this.latestVersion;
        return data; 
    }
}

export interface IApplicationModel {
    appID?: string | undefined;
    title?: string | undefined;
    advertisingImage?: string | undefined;
    helpContent?: string | undefined;
    latestVersion?: string | undefined;
}

export class VersionModel implements IVersionModel {
    appID?: string | undefined;
    versionNum?: string | undefined;
    title?: string | undefined;
    releaseNotes?: string | undefined;
    specialNote?: string | undefined;

    constructor(data?: IVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appID = data["appID"];
            this.versionNum = data["versionNum"];
            this.title = data["title"];
            this.releaseNotes = data["releaseNotes"];
            this.specialNote = data["specialNote"];
        }
    }

    static fromJS(data: any): VersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new VersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appID"] = this.appID;
        data["versionNum"] = this.versionNum;
        data["title"] = this.title;
        data["releaseNotes"] = this.releaseNotes;
        data["specialNote"] = this.specialNote;
        return data; 
    }
}

export interface IVersionModel {
    appID?: string | undefined;
    versionNum?: string | undefined;
    title?: string | undefined;
    releaseNotes?: string | undefined;
    specialNote?: string | undefined;
}

export class DownloadContentModel implements IDownloadContentModel {
    appID?: string | undefined;
    title?: string | undefined;
    platform?: string | undefined;
    helpImage?: string | undefined;
    helpText?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IDownloadContentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appID = data["appID"];
            this.title = data["title"];
            this.platform = data["platform"];
            this.helpImage = data["helpImage"];
            this.helpText = data["helpText"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): DownloadContentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadContentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appID"] = this.appID;
        data["title"] = this.title;
        data["platform"] = this.platform;
        data["helpImage"] = this.helpImage;
        data["helpText"] = this.helpText;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IDownloadContentModel {
    appID?: string | undefined;
    title?: string | undefined;
    platform?: string | undefined;
    helpImage?: string | undefined;
    helpText?: string | undefined;
    fileName?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}